import React, { useEffect, useState } from "react";
import { useLoader } from "../../context/LoaderContext";
import {
  IBannerData,
  IConsentLetters,
  ISurgicalData,
} from "../../exports/interfaces";
import { dynamicFailed } from "../../hooks/useToast";
import SurgicalDomainsBanner from "../../components/surgicaldomains/SurgicalDomainsBanner";
import SurgicalDomainsDescription from "../../components/surgicaldomains/SurgicalDomainsDescription";
import {
  fetchConsentLetters,
  fetchMentoplasty,
  fetchMentoplastyBanner,
} from "../../api/SurgicalDomainApi";

const Mentoplasty = () => {
  const { setLoading } = useLoader();
  const [mentoplastyBanner, setMentoplastyBanner] = useState<IBannerData[]>([]);
  const [mentoplastyData, setMentoplastyData] = useState<ISurgicalData[]>([]);
  const [consentLetters, setConsentLetters] = useState<IConsentLetters[]>([]);

  useEffect(() => {
    setLoading(true);
    // Promise.all([fetchArchiveBanner(), fetchVideoData()])
    Promise.all([
      fetchMentoplastyBanner(),
      fetchMentoplasty(),
      fetchConsentLetters(),
    ])
      .then(([mentoplastyBannerData, mentoplastyData, consentLettersData]) => {
        setMentoplastyBanner(mentoplastyBannerData);
        setMentoplastyData(mentoplastyData);
        setConsentLetters(consentLettersData);
        // setArchiveVideoData(videoData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <SurgicalDomainsBanner
        bannerData={mentoplastyBanner}
        page={"Mentoplasty"}
      />
      <SurgicalDomainsDescription descriptionData={mentoplastyData} consentLetters={consentLetters} surgicalName='Mentoplasty'/>
    </>
  );
};

export default Mentoplasty;
